import React, { useEffect } from "react";

/**
 * Inserts a <script type="application/ld+json"> with the given JSON-LD data
 * into <head>. Removes it on unmount. Each instance is uniquely keyed by id.
 */
export default function StructuredData({ id, data }) {
  useEffect(() => {
    const elementId = `ld-${id}`;
    let el = document.getElementById(elementId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elementId;
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);
    return () => {
      const remove = document.getElementById(elementId);
      if (remove) remove.remove();
    };
  }, [id, data]);

  return null;
}
